import * as types from "../actions/actionTypes";
const initialState = {
  processing: false,
  loading: true,
  importedFileResponse: null,
  importedFileData: [],
  error: ""
};

const Transaction = (state = initialState, action) => {
  switch (action.type) {
    case types.IMPORT_FILE_TRANSACTIONS_REQUEST:
      return { ...state, processing: true };
    case types.IMPORT_FILE_TRANSACTIONS_SUCCESS:
      return { ...state, processing: false, importedFileResponse: action.data };
    case types.IMPORT_FILE_TRANSACTIONS_FAILURE:
      return {
        ...state,
        processing: false
      };

    case types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_REQUEST:
      return { ...state, processing: true };
    case types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_SUCCESS:
      return { ...state, processing: false };
    case types.CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_FAILURE:
      return { ...state, processing: false };

    case types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST:
      return { ...state, loading: true, error: "" };
    case types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS:
      return { ...state, loading: false, importedFileData: action.data };
    case types.GET_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE:
      return { ...state, loading: false, error: action.error };

    case types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST:
      return { ...state, processing: true };
    case types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS:
      return { ...state, processing: false };
    case types.STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE:
      return { ...state, processing: false };

    default:
      return state;
  }
};

export default Transaction;
